import { commonTranslations } from '@/libraries/ui/commonTranslations'

export const fi = {
  app: {
    title: 'Tanssiaistietokanta',
    copyright: 'Tanssitietokannan tekijät',
    licenceLink: 'https://raw.githubusercontent.com/Purrrrrr/Tanssiaistietokanta/main/frontend/LICENSE',
  },
  navigation: {
    events: 'Tapahtumat',
    dances: 'Tanssit',
    breadcrumbs: 'Murupolku',
    moveToContent: 'Siirry pääsisältöön',
    volunteers: 'Vapaaehtoiset',
    ballrooms: 'Tanssisalit',
    userSettings: 'Käyttäjäasetukset',
    menu: 'Valikko',
    login: 'Kirjaudu',
    logout: 'Kirjaudu ulos',
    privacyPolicy: 'Tietosuojaseloste',
  },
  breadcrumbs: {
    app: 'Tanssiaistietokanta',
    dances: 'Tanssit',
    eventProgram: 'Tanssiaisohjelma',
  },
  validationMessage: {
    default: 'Tarkista arvo',
    required: 'Täytä kenttä',
    requiredList: 'Kentän täytyy sisältää ainakin yksi arvo',
    /* eslint-disable no-template-curly-in-string */
    minLength: 'Syötä ainakin ${min} merkkiä',
    maxLength: 'Syötä korkeintaan ${max} merkkiä',
    min: 'Pitää olla ainakin ${min}',
    max: 'Saa olla korkeintaan ${max}',
    /* eslint-enable no-template-curly-in-string */
  },
  dateFormat: 'dd.MM.yyyy',
  dateTimeFormat: 'dd.MM.yyyy HH:mm',
  // Field names and enum translations go here
  domain: {
    document: {
      title: 'Otsikko',
      _updatedAt: 'Muokattu',
      content: 'Sisältö',
    },
    event: {
      name: 'Nimi',
      eventDate: 'Tapahtuman ajankohta',
      ballDateTime: 'Tanssiaisten ajankohta',
      accessControl: {
        viewAccess: {
          public: 'Julkinen',
          limited: 'Rajoitettu',
        },
      },
      eventRegistrationSystem: 'Tapahtuman ilmoittautumisjärjestelmä',
      ballroom: 'Tanssiaisten sali',
      EventRemoveBlocker: {
        HasRegisteredVolunteers: 'Tällä pajalla on ilmoitettuja vapaaehtoisia, joten sitä ei voi poistaa.',
        HasRegisteredWorkshops: 'Tällä opetuskerralla on vapaaehtoisia, joten sitä ei voi poistaa.',
      },
    },
    EventRegistrationSystem: {
      None: 'Ei käytössä',
      Kompassi: 'Kompassi',
    },
    EventVolunteerAssignmentRegistrationStatus: {
      None: 'Ei ilmoitettu',
      RegisteredToEventSystem: 'Ilmoitettu Kompassiin',
      AcceptedRegistration: 'Hyväksynyt kompassi-kutsun',
      InformedToOrganizers: 'Ilmoitettu muuta kautta',
      RegistrationCancelled: 'Ilmoittautuminen peruttu',
    },
    allowedViewers: {
      everyone: 'Kaikki käyttäjät',
      loggedIn: 'Kirjautuneet käyttäjät',
      chosenUsers: 'Valitut käyttäjät',
      add: 'Lisää...',
      removeUser: 'Poista käyttäjä __name__',
      noUsers: 'Ei käyttäjiä',
    },
    dance: {
      name: 'Nimi',
      description: 'Kuvaus ja lyhyt ohje',
      descriptionPreview: 'Kuvauksen diashow-esikatselu',
      remarks: 'Huomautuksia',
      duration: 'Kesto',
      prelude: 'Alkusoitto',
      formation: 'Tanssikuvio',
      source: 'Lähde',
      sourceInfo: '(esim. Playford, 1709)',
      category: 'Kategoria',
      instructions: 'Pidemmät tanssiohjeet printtiin',
      slideStyleId: 'Tanssiaisten diatyyli',
      wikipageName: 'Tanssiwikin sivu',
      events: 'Tapahtumat',
      formationDiagrams: 'Kuvionmuodostusohjeet',
    },
    formationDiagram: {
      ballroom: 'Tanssisali',
      description: 'Kuvaus',
      diagram: 'Kuvio',
    },
    ballroom: {
      venueName: 'Tapahtumapaikka',
      roomName: 'Sali',
      map: 'Salin kartta',
    },
    slideStyles: {
      default: 'Valkoinen',
      dark: 'Tumma',
      flowerBig: 'Kukka iso __number__',
      flowerFramed: 'Kukka reunus __number__',
    },
    eventVolunteer: {
      volunteer: 'Vapaaehtoinen',
      name: 'Nimi',
      status: 'Tila',
      interestedIn: 'Kiinnostuksen kohteet',
      assignments: 'Valittu tehtäviin',
      taskRoles: 'Tehtävät',
      interested: 'Kiinnostunut',
      assigned: 'Valittu',
      wishes: 'Toiveet',
      notes: 'Muistiinpanot',
      noInterests: 'Ei kiinnostuksen kohteita',
      noWishes: 'Ei erityisiä toiveita',
      EventVolunteerStatus: {
        Accepted: 'Mukana työvoimassa',
        Cancelled: 'Perunut osallistumisensa',
        CanWorkAsBackup: 'Voi toimia varalla',
        Interested: 'Ilmoittanut kiinnostuksensa',
        Rejected: 'Ei mukana työvoimassa',
      },
      shortEventVolunteerStatus: {
        Accepted: 'Työssä',
        Cancelled: 'Peruutus',
        CanWorkAsBackup: 'Varalla',
        Interested: 'Kiinnostunut',
        Rejected: 'Ei mukana',
      },
    },
    volunteer: {
      name: 'Nimi',
      volunteeredIn: 'Työskennellyt työpajoissa',
    },
    user: {
      name: 'Nimi',
      username: 'Käyttäjätunnus',
    },
  },
  components: {
    grantEditor: {
      accessRights: 'Pääsyoikeudet',
      allowedViewers: 'Näkyvyys',
      principal: 'Valtuutettu',
      role: 'Rooli',
      roles: {
        viewer: 'Katsoja',
        organizer: 'Järjestäjä',
        teacher: 'Muokkaaja',
      },
      grants: 'Valtuutukset',
      loggedInUsers: 'Kirjautuneet käyttäjät',
      addGrant: 'Lisää pääsyoikeus...',
      remove: 'Poista',
      confirmRemove: 'Haluatko varmasti poistaa valtuutuksen käyttäjältä __user__?',
      nothingToAdd: 'Ei mahdollisiä lisättäviä',
      noGrants: 'Ei pääsyoikeuksia',
    },
    slide: {
      afterThis: 'Tämän jälkeen',
      teachedInSet: 'Opetettu setissä',
    },
    projectionSettings: {
      title: 'Projisoinnin marginaalit',
      top: 'Yläreuna',
      bottom: 'Alareuna',
      left: 'Vasen reuna',
      right: 'Oikea reuna',
      remembered: '',
      help: 'Marginaalit varaavat mustaa tilaa reunoille. Asetukset muistetaan tässä selaimessa.',
      reset: 'Nollaa marginaalit',
    },
    loginForm: {
      login: 'Kirjaudu sisään',
      username: 'Käyttäjätunnus',
      password: 'Salasana',
      invalidCredentials: 'Virheellinen käyttäjätunnus tai salasana',
    },
    deleteButton: {
      cancel: 'Peruuta',
      delete: 'Poista',
    },
    loadingState: {
      loading: 'Ladataan...',
      connectionError: 'Yhteydenotto palvelimeen ei onnistu',
      errorMessage: 'Tietojen lataaminen epäonnistui',
      tryAgain: 'Yritä uudelleen',
    },
    dance: {
      createDanceButton: {
        createDance: 'Uusi tanssi',
        untitledDance: 'Nimetön tanssi #__number__',
        danceCreated: 'Tanssi __name__ luotu',
        uploadDance: 'Tuo tanssi tiedostosta',
      },
    },
    danceChooser: {
      searchDance: 'Etsi tanssia...',
      emptyDancePlaceholder: 'Tansseja ei löytynyt',
      createDance: 'Luo uusi tanssi',
      categories: {
        missingFromWorkshops: 'Puuttuvat työpajoissa opetetut tanssit',
        dances: 'Tanssit',
        other: 'Muut',
      },
    },
    wikipageSelector: {
      searchPage: 'Etsi sivua...',
      suggestions: 'Ehdotukset',
      wikipage: 'Tanssiohjeet',
      spam: 'Roskapostisivut',
    },
    danceCategoryChooser: {
      anyCategory: 'Kaikki kategoriat',
      noCategory: 'Ei kategoriaa',
    },
    danceEditor: {
      deleteDance: 'Poista tanssi',
      deleteConfirmation: 'Haluatko varmasti poistaa tämän tanssin?',
      danceUsedInEvents: {
        one: 'Yksi tanssitapahtuma',
        many: '__count__ tanssitapahtumaa',
      },
      danceEvents: 'Tanssitapahtumat',
      copyFromDancewiki: 'Kopioi ohjeet tanssiwikistä',
      suggestions: 'Ehdotuksia',
      editInstructions: 'Muokkaa tanssiohjeita',
      noFormationInstructions: 'Ei kuvioonmuodostussohjeita',
      noFormationDiagrams: 'Ei kuvioonmuodostussohjeita',
      addFormationDiagram: 'Lisää kuvionmuodostusohje',
      createFormationDiagram: 'Luo uusi kuvionmuodostusohje',
      noBallroom: 'Ei tanssisalia',
    },
    AddFormationDiagramForm: {
      createFormationDiagram: 'Luo kuvionmuodostusohje',
    },
    danceWikiPreview: {
      danceInDanceWiki: 'Tanssi tanssiwikissä',
      danceFetched: 'Sivun tiedot ja sisältö haettu __date__',
      openInstructions: 'Avaa wikin ohje',
      fetchInstructions: 'Päivitä tiedot',
      fetching: 'Haetaan tietoja...',
    },
    workshopEditor: {
      dances: 'Tanssit',
      addDance: 'Lisää tanssi: ',
      noDances: 'Tanssilista on tyhjä.',
      name: 'Nimi',
      required: '(pakollinen)',
      abbreviation: 'Lyhennemerkintä',
      abbreviationHelp: 'Lyhennemerkintä näytetään settilistassa työpajassa opetettujen tanssien kohdalla',
      abbreviationTaken: 'Lyhenne __abbreviation__ on jo käytössä toisessa pajassa. Tässä tapahtumassa ovat jo käytössä seuraavat lyhenteet: __abbreviations',
      registrationStatus: 'Ilmoittautumistilanne',
      WorkshopRegistrationStatus: {
        None: 'Ei ilmoitettu',
        RegisteredToEventSystem: 'Ilmoitettu ohjelmaksi Kompassiin',
        InformedToOrganizers: 'Ilmoitettu muuta kautta',
      },
      description: 'Työpajan kuvaus',
      teachers: 'Opettaja(t)',
      instanceSpecificDances: 'Joka opetuskerralla on omat tanssinsa',
      instancesAndDances: 'Opetuskerrat ja tanssit',
      instances: 'Opetuskerrat',
      instance: 'Opetuskerta',
      addInstance: 'Lisää opetuskerta',
      cannotRemoveWithRegisteredVolunteers: 'Tällä pajalla on ilmoitettuja vapaaehtoisia, joten sitä ei voi poistaa.',
      cannotRemoveInstanceWithVolunteers: 'Tällä opetuskerralla on vapaaehtoisia, joten sitä ei voi poistaa.',
      instanceAbbreviation: 'Kerran lyhenne',
      instanceAbbreviationHelp: 'Lyhennemerkintä näytetään työpajan lyhennemerkinnän rinnalla niiden tanssien kohdalla, jotka on opetettu ainoastaan tällä opetuskerralla.',
      instanceAbbreviationExample: 'Tämä lyhenne näytetään muodossa __abbreviation__',
      dateTime: 'Ajankohta',
      duration: 'Kesto minuuteissa',
    },
    volunteerSelector: {
      createNewVolunteer: 'Luo uusi vapaaehtoinen',
      noVolunteers: 'Ei vapaaehtoisia',
      addVolunteer: 'Lisää vapaaehtoinen',
    },
    volunteerChooser: {
      searchVolunteer: 'Etsi vapaaehtoista...',
      noVolunteers: 'Ei vapaaehtoisia',
      createNewVolunteer: 'Luo uusi vapaaehtoinen',
    },
    volunteerAssignmentEditor: {
      addAssignment: 'Lisää työtehtävä',
      legend: 'Merkkien selitykset',
      addRole: 'Lisää rooli',
      noRoles: 'Ei rooleja',
      addVolunteer: 'Lisää vapaaehtoinen',
      noVolunteers: 'Ei vapaaehtoisia',
      noAssignments: 'Ei annettuja työtehtäviä',
      selectedAssignments: {
        one: 'Valittu 1 työtehtävä',
        many: 'Valittu __count__ työtehtäväää',
      },
      setRegistrationStatus: {
        one: 'Aseta valitun ilmoittautumistilanne',
        many: 'Aseta valittujen ilmoittautumistilanne',
      },
      cannotRemoveRegisteredAssignment: 'Tapahtumaan ilmoitettuja vapaaehtoisia ei voi poistaa ilman ilmoittautumisen perumista.',
      removeVolunteer: 'Poista vapaaehtoinen',
      removeRole: 'Poista rooli',
      removeSelected: {
        one: 'Poista valittu',
        many: 'Poista valitut',
      },
      removeAssignmentsConfirmation: {
        title: {
          one: 'Poistetaanko työtehtävä?',
          many: 'Poistetaanko työtehtävät?',
        },
        text: {
          one: 'Haluatko varmasti poistaa seuraavan vapaaehtoisen työtehtävän?',
          many: 'Haluatko varmasti poistaa seuraavat vapaaehtoisten työtehtävät?',
        },
      },
      name: 'Nimi',
      role: 'Rooli',
      workshop: 'Työpaja',
      noWorkshop: 'Ei työpajaa',
      instance: 'Opetuskerta',
      allInstances: 'Kaikki',
      registrationStatus: 'Tilanne',
      chooseStatus: 'Valitse',
    },
    addVolunteerAssignmentForm: {
      title: 'Lisää työtehtäviä',
      chooseAssignmentTarget: 'Rooli tai vapaaehtoinen, jolle tehtäviä lisätään',
      roleOrVolunteer: 'Roolin tai vapaaehtoisen nimi',
      role: 'Rooli',
      volunteer: 'Vapaaehtoinen',
      empty: 'Tyhjennä valinta',
      workshop: 'Työpaja',
      instance: 'Opetuskerta',
      chooseWorkshop: 'Valitse työpaja',
      noResults: 'Ei tuloksia',
      assignmentsToAdd: 'Lisättävät työtehtävät',
      noAssignmentsAdded: 'Ei lisättyjä työtehtäviä',
      deleteAssignment: 'Poista lisättävä työtehtävä',
      addAssignments: {
        zero: 'Lisää työtehtävä',
        one: 'Lisää työtehtävä',
        many: 'Lisää työtehtävät',
      },
    },
    assignmentsWarnings: {
      volunteersWithoutAssignments: {
        one: 'Yhdellä vapaaehtoisella ei ole työtehtäviä',
        many: '__count__ vapaaehtoisella ei ole työtehtäviä',
      },
      nonRegisteredAssignments: {
        one: 'Yksi työtehtävä ilmoittamatta kompassiin.',
        many: '__count__ työtehtävää ilmoittamatta kompassiin.',
      },
      nonAcceptedAssignments: {
        one: 'Yksi hyväksymätön kompassi-kutsu',
        many: '__count__ hyväksymätöntä kompassi-kutsua',
      },
      cancelledAssignments: {
        one: 'Tapahtumassa on yksi perumaton työtehtävä, jonka vapaaehtoinen on perunut osallistumisensa',
        many: 'Tapahtumassa on __count__ perumatonta työtehtävää, joiden vapaaehtoiset ovat peruneet osallistumisensa',
      },
    },
    eventRoleSelector: {
      workshopRoles: 'Työpajaroolit',
      eventRoles: 'Tapahtumaroolit',
    },
    eventProgramEditor: {
      fields: {
        eventProgram: {
          name: 'Ohjelman nimi',
          description: 'Ohjelman kuvaus',
          notes: 'Muistiinpanot',
          duration: 'Ohjelman kesto',
          showInLists: 'Näytä ohjelma tanssilistoissa',
        },
        intervalMusic: {
          useDefaultTexts: 'Käytä oletusotsikkoa ja kuvausta',
          name: 'Otsikko diashowssa',
          description: 'Tarkempi kuvaus',
          showInLists: 'Näytä taukomusiikki tanssilistoissa',
        },
        danceSetName: 'Tanssisetin nimi',
        eventDefaultStyle: 'Ohjelman oletustyyli',
        intervalMusicAtEndOfSet: 'Taukomusiikki setin lopussa',
        intervalMusicDuration: 'Taukomusiikin kesto',
        pauseDuration: 'Tanssien välinen tauko',
        programTitle: 'Ohjelman otsikko',
        style: 'Tyyli',
      },
      slides: {
        moveToSlide: 'Siirry diaan',
      },
      danceCount: {
        zero: '-',
        one: '1 tanssi',
        many: '__count__ tanssia',
      },
      requestedDanceCount: {
        zero: '-',
        one: '1 toivetanssi',
        many: '__count__ toivetanssia',
      },
      otherProgramCount: {
        zero: '-',
        one: '1 muu ohjelma',
        many: '__count__ muuta ohjelmaa',
      },
      buttons: {
        addDance: 'Lisää tanssi',
        addDanceSet: 'Lisää tanssisetti',
        addInfo: 'Lisää muuta ohjelmaa',
        addIntroductoryInfo: 'Lisää alkutiedote',
        editDanceSetName: 'Muokkaa tanssisetin nimeä',
        removeNote: 'Poista muistiinpano',
        editNote: 'Muokkaa muistiinpanoja',
        cancel: 'Peruuta',
        removeDanceSet: 'Poista setti',
        remove: 'Poista',
      },
      columnTitles: {
        name: 'Nimi',
        notes: 'Muistiinpanot',
        duration: 'Kesto',
      },
      titles: {
        introductoryInformation: 'Alkutiedotukset',
        customIntervalMusicTexts: 'Mukautetut kuvaukset',
        defaultIntervalMusicTexts: 'Taukomusiikin oletuskuvaukset',
      },
      placeholderNames: {
        newProgramItem: 'Uusi ohjelmanumero',
        danceSet: 'Setti __number__',
      },
      programTypes: {
        Dance: 'Tanssi',
        RequestedDance: 'Toivetanssi',
        EventProgram: 'Muu ohjelma',
        IntervalMusic: 'Taukomusiikki',
      },
      dance: 'Tanssi',
      chooseDance: 'Valitse tanssi',
      duration: {
        pausesIncluded: '(taukoineen)',
        dances: '(tanssit)',
      },
      programListIsEmpty: 'Ei ohjelmaa',
      danceProgramIsEmpty: 'Ei tanssiohjelmaa.',
      missingDanceInstructionsWarning: {
        programIsMissingInstructions: 'Ohjelmasta puuttuu tanssiohjeita',
        dancesWithoutInstructions: {
          one: 'Diashowssa on yksi tanssi, jolta puuttuu tanssiohjeet.',
          many: 'Diashowssa on __count__ tanssia, joilta puuttuu tanssiohjeet.',
        },
        clickLinksToOpenSlide: 'Klikkaa linkkejä muokataksesi ohjeita.',
        inSet: 'setissä',
        teachedInSet: 'opetettu setissä',
        missingDancesCount: {
          one: 'puuttuva tanssiohje',
          many: 'puuttuvaa tanssiohjetta',
        },
      },
      missingDancesWarning: {
        title: {
          one: 'Ohjelmasta puuttuu yksi työpajoissa opetettu tanssi.',
          many: 'Ohjelmasta puuttuu __count__ työpajoissa opetettua tanssia.',
        },
      },
      duplicateDancesWarning: {
        title: {
          one: 'Seuraava tanssi esiintyy ohjelmassa useamman kerran',
          many: 'Seuraavat tanssit esiintyvät ohjelmassa useamman kerran',
        },
        inDanceSets: {
          one: 'setissä',
          many: 'seteissä',
        },
      },
      danceCategoryStats: {
        title: 'Tanssien määrät tanssiaisissa kategorioittain:',
      },
    },
    eventSlideEditor: {
      linkToCompleteDance: 'Tanssi tanssitietokannassa',
      currentItemAlwaysShownInLists: 'Huomaathan, että ollessaan tämänhetkinen dia näkyy tämä ohjelma settilistassa riippumatta näkyvyysasetuksesta.',
      danceTitle: 'Tanssin tiedot',
      nextSlide: 'Seuraava dia',
      previousSlide: 'Edellinen dia',
    },
    supportedBrowserWarning: {
      unsupportedBrowser: 'Selaimesi ei ole tuettu',
      continueAnyWay: 'Jatka sivustolle',
      downloadBetterBrowser: 'Lataa uusin Firefox',
      siteMayNotWork: 'Selaimesi ei tue kaikkia tämän sivuston käyttämiä ominaisuuksia. Jos jatkat, sivusto ei välttämättä toimi tarkoituksenmukaisesti.',
      possibleSupportedBrowsers: 'Tanssitietokanta on kehitetty ja testattu enimmäkseen Firefoxilla, mutta se tukee ainakin seuraavien selaimien uusimpia versioita:',
    },
    files: {
      name: 'Nimi',
      size: 'Koko',
      _updatedAt: 'Muokattu',
      noFiles: 'Ei tiedostoja',
      addFile: 'Lisää tiedosto',
      filesSelected: {
        one: 'Yksi tiedosto valittu, yhteensä __sizeTotal__',
        many: '__count__ tiedostoa valittu, yhteensä __sizeTotal__',
      },
      downloadSelected: 'Lataa valitut',
      DeleteSelectionButton: {
        text: 'Poista kaikki',
        confirmTitle: {
          one: 'Poistetaanko tiedosto?',
          many: 'Poistetaanko __count__ tiedostoa?',
        },
        confirmText: 'Haluatko varmasti poistaa nämä tiedostot?',
        successMessage: {
          one: '1 tiedosto poistettu',
          many: '__count__ tiedostoa poistettu',
        },
      },
      uploadingFiles: {
        one: 'Lähetetään tiedostoa...',
        many: 'Lähetetään __count__ tiedostoa...',
      },
      pending: 'Odotetaan lähetysvuoroa...',
      alreadyExistsConfirm: {
        title: 'Tiedosto on jo olemassa',
        content: 'Tiedosto __filename__ on jo olemassa, haluatko korvata sen?',
        ok: 'Korvaa',
        cancel: 'Peruuta',
      },
      alreadyUploadingAlert: {
        title: 'Lataat jo tiedostoa',
        content: 'Tiedosto __filename__ on jo latausjonossa. Et voi ladata samaan paikkaan kahta samannimistä tiedostoa.',
        ok: 'Ok',
      },
      DeleteFileButton: {
        text: 'Poista',
        confirmTitle: 'Poistetaanko tiedosto?',
        confirmText: 'Haluatko varmasti poistaa tiedoston __filename__?',
        successMessage: 'Tiedosto poistettu',
      },
      RenameFileButton: {
        text: 'Nimeä uudelleen',
        rename: 'Nimeä uudelleen',
        ok: 'Ok',
        errorTitle: 'Virhe uudelleennimeämisessä',
        duplicateError: 'Tämän niminen tiedosto on jo olemassa',
        successMessage: 'Tiedosto nimetty uudelleen',
      },
      UploadButton: {
        upload: 'Lähetä tiedosto',
        errorReason: {
          too_big: 'Tiedosto on liian suuri. Et voi lähettää tiedostoja, joiden koko on yli __max_size__',
          server: 'Virhe tiedoston lähetyksessä: __message__',
          unknown: 'Tuntematon virhe tiedoston lähetyksessä',
          already_exists: 'Tiedosto __filename__ on jo olemassa',
          file_is_infected: 'Tiedosto sisältää haittaohjelman',
        },
      },
    },
    documents: {
      DocumentList: {
        noDocuments: 'Ei asiakirjoja',
        editDocument: 'Muokkaa asiakirjaa',
        previewDocument: 'Esikatsele asiakirjaa',
        closePreview: 'Sulje esikatselu',
      },
      CreateDocumenButton: {
        createDocument: 'Uusi asiakirja',
        untitledDocument: 'Nimetön asiakirja',
      },
      DeleteDocumenButton: {
        deleteDocument: 'Poista asiakirja',
        deleteConfirmation: 'Haluatko varmasti poistaa tämän asiakirjan?',
      },
      DocumentViewPage: {
        editDocument: 'Muokkaa asiakirjaa',
      },
      DocumentEditPage: {
        viewDocument: 'Palaa lukutilaan',
      },
    },
  },
  routes: {
    notFound: {
      pageNotFound: 'Sivua ei löytynyt',
      returnToHome: 'Palaa etusivulle',
    },
    dances: {
      list: {
        pageTitle: 'Tanssit',
        view: 'Näkymä',
        viewMode: {
          tight: 'Tiivis',
          extended: 'Laaja',
        },
        noCategory: 'Ei kategoriaa',
        showingNDances: {
          one: 'Näytetään 1 tanssi',
          many: 'Näytetään __count__ tanssia',
        },
        noDances: 'Ei tansseja',
      },
      dance: {
        backToDanceList: 'Takaisin tanssilistaan',
      },
    },
    events: {
      list: {
        pageTitle: 'Tanssiaistietokanta',
        welcomeMessage: {
          message: 'Tervetuloa Tanssiaistietokantaan! Tälle sivustolle on koottu joitakin Suomessa järjestettäviä historiallisen tanssin tapahtumia',
          danceInstructionsPostfix: ' ja niihin liittyviä ',
          danceInstructions: 'tanssiohjeita',
        },
        loginToEdit: {
          moveTo: 'Et ole kirjautunut sisään. Muokataksesi tapahtumia, siirry ',
          loginPage: 'kirjautumissivulle',
          toEdit: ' ja kirjaudu sisään.',
        },
        weHaveXEvents: {
          zero: 'Kannassa ei ole tällä hetkellä yhtäkään tanssitapahtumaa.',
          one: 'Kannassa on tällä hetkellä yksi tanssitapahtuma.',
          many: 'Kannassa on tällä hetkellä __count__ tanssitapahtumaa.',
        },
        youcanViewDancesIn: 'Voit myös tarkastella tanssitapahtumien tansseja',
        youcanEditDancesIn: 'Voit myös muokata tanssitapahtumien tansseja',
        danceDatabaseLinkName: 'tanssitietokannasta',
        danceEvents: 'Tanssitapahtumat tietokannassa',
        noEvents: 'Ei tapahtumia',
        createEvent: 'Uusi tapahtuma',
        name: 'Nimi',
        date: 'Päivämäärä',
      },
      new: {
        newEventBreadcrumb: 'Uusi tapahtuma',
        newEvent: 'Luo uusi tapahtuma',
        create: 'Luo tapahtuma',
      },
      event: {
        backToFrontPage: 'Takaisin tapahtuman etusivulle',
        menu: {
          title: 'Tapahtuman tiedot',
          basicInfo: 'Etusivu',
          editBasicInfo: 'Tapahtuman tiedot',
          volunteers: 'Vapaaehtoiset',
          assignments: 'Työtehtävät',
          assignmentsAndRegistrationStatus: 'Työtehtävät ja ilmoittautumistilanne',
          workshops: 'Työpajat',
          addWorkshop: 'Lisää työpaja',
          ball: {
            title: 'Tanssiaiset',
            ballProgram: 'Suunnittele tanssiaisohjelmaa',
            openSlideShow: 'Tanssiaisten diashow',
            editSlideShow: 'Muokkaa diashowta',
          },
          print: {
            title: 'Tulosta',
            printBallDanceList: 'Tulosta settilista',
            danceCheatlist: 'Osaan tanssin -lunttilappu',
            danceInstructions: 'Työpajojen ohjelma ja tanssiohjeet',
          },
          documents: 'Asiakirjat',
        },
        index: {
          ballProgram: 'Tanssiaisohjelma',
          ballDateTime: 'Tanssiaiset järjestetään __dateTime__.',
          youCanEditProgramOnPages: 'Voit myös muokata tanssiaisohjelmaa sivuilla',
          editProgram: 'Muokkaa tanssiaisohjelmaa',
          and: 'ja',
          editSlideShow: 'Muokkaa diashowta',
          editWorkshop: 'Muokkaa työpajaa',
          noProgram: 'Ei ohjelmaa',
          requestedDance: {
            one: 'Toivetanssi',
            many: '__count__ toivetanssia',
          },
          workshops: 'Työpajat',
          noWorkshops: 'Ei työpajoja',
          createWorkshop: 'Uusi työpaja',
          createWorkshopForm: {
            title: 'Lisää uusi työpaja',
            workshopName: 'Työpajan nimi',
            createWorkshop: 'Luo työpaja',
          },
          documents: 'Tapahtuman asiakirjat',
          files: 'Tapahtumaan liittyvät tiedostot',
        },
        documents: {
          document: {
            edit: {
              breadcrumb: 'Asiakirjan muokkaus',
            },
          },
        },
        edit: {
          title: 'Muokkaa tapahtuman tietoja',
          deleteEvent: 'Poista tämä tapahtuma',
          eventDeleteConfirmation: 'Haluatko varmasti poistaa tapahtuman __eventName__?',
          cannotChangeEventRegistrationSystem: 'Tapahtuman ilmoittautumisjärjestelmää ei voi muuttaa, koska tapahtumalla on jo järjestelmään ilmoitettuja vapaaehtoisia.',
        },
        volunteers: {
          title: 'Vapaaehtoiset',
          filterByRole: 'Rooli',
          allRoles: 'Kaikki roolit',
          noVolunteers: 'Ei vapaaehtoisia',
          Nvolunteers: {
            one: 'yksi vapaaehtoinen',
            many: '__count__ vapaaehtoista',
          },
          selectedVolunteers: {
            one: 'yksi valittu',
            many: '__count__ valittu',
          },
          setStatus: 'Aseta ilmoittautumistilanne',
          addVolunteer: 'Lisää vapaaehtoinen',
          cannotDeleteRegisteredVolunteer: 'Tapahtumaan ilmoitettuja vapaaehtoisia ei voi poistaa ilman ilmoittautumisen perumista.',
          deleteVolunteer: 'Poista vapaaehtoinen',
          deleteConfirmation: 'Haluatko varmasti poistaa tämän vapaaehtoisen tapahtumasta?',
        },
        assignments: {
          assignments: 'Työtehtävät',
          assignmentsAndRegistrationStatus: 'Työtehtävät ja Kompassi-ilmoittautumistilanne',
        },
        workshop: {
          delete: 'Poista työpaja',
          deleteConfirmation: 'Haluatko varmasti poistaa tämän työpajan?',
          infoAndDances: 'Tiedot ja tanssit',
          volunteersAndAssignments: 'Vapaaehtoiset ja työvuorot',
          documentsAndFIles: 'Asiakirjat ja tiedostot',
          documents: 'Työpajan asiakirjat',
          files: 'Työpajaan liittyvät tiedostot',
        },
        ballProgram: {

        },
        program: {
          main: {
            pageTitle: 'Tanssiaisohjelma',
          },
          slides: {
            pageTitle: 'Tanssiaisten diashow',
          },
        },
        print: {
          ballDanceList: {
            showLinks: 'Linkit tanssiwikiin',
            style: {
              default: 'Oletus',
              'three-columns': 'Rinnakkaiset setit',
              large: 'Yksi setti per arkki',
            },
            print: 'Tulosta',
            emptyLinesAreRequestedDances: 'Tyhjät rivit ovat toivetansseja.',
            workshopNameIsInParenthesis: 'Suluissa opetussetti',
          },
          danceCheatlist: {
            rows: 'Rivien määrä',
            cols: 'Sarakkeiden määrä',
            landscape: 'Tulosta vaakasuunnassa',
            nrOfCopies: {
              one: '1 kopio per sivu',
              many: '__count__ kopiota per sivu',
            },
            showHelpText: 'Näytä luntin ohjeteksti',
            print: 'Tulosta',
            helpText: 'Rastita tähän, jos osaat tanssin. Näin ei tanssiaisissa tarvitse miettiä, mikä tanssi on kyseessä.',
            iCanDanceThis: 'Osaan tanssin',
            danceName: 'Nimi',
          },
          danceInstructions: {
            clickInstructionsToEdit: 'Klikkaa ohjetta muokataksesi sitä, voit myös hakea tietoja tanssiwikistä klikkaamalla nappeja, jotka avautuvat kun tuot hiiren tanssin päälle. Kun ohjeet ovat mieleisesi, voit joko tulostaa tämän sivun tai valita ohjetekstit ja kopioida ne haluamaasi tekstinkäsittelyohjelmaan.',
            defaultStylingDescription: 'Pitkissä ohjeissa on oletustyyli, jossa ensimmäinen kappale on kursivoitu. Tämän tarkoituksena on eritellä tanssin ja tanssikuvion lyhyt kuvaus lopusta ohjeesta ilman tilaa vievää otsikointia.',
            showWorkshops: 'Näytä työpajojen ja tanssiaisten kuvaukset',
            showDances: 'Näytä tanssiohjeet',
            showShortInstructions: 'Näytä lyhyet ohjeet',
            hilightEmpty: 'Korosta tanssit ilman ohjeita',
            selectAndCopy: 'Kopioi ohjeet leikepöydälle',
            instructionsCopied: 'Ohjeet kopioitu',
            print: 'Tulosta',
            workshopsAndBall: 'Työpajat ja tanssiaiset',
            ball: 'Tanssiaiset',
            dances: 'Tanssit',
            danceInstructions: 'Tanssiohjeet',
          },
        },
      },
    },
    users: {
      list: {
        pageTitle: 'Käyttäjät',
        noUsers: 'Ei käyttäjiä',
      },
    },
    volunteers: {
      pageTitle: 'Vapaaehtoiset',
      Nvolunteers: {
        one: '1 vapaaehtoinen',
        many: '__count__ vapaaehtoista',
      },
      noVolunteers: 'Ei vapaaehtoisia',
      addVolunteer: 'Lisää vapaaehtoinen',
      deleteVolunteer: 'Poista vapaaehtoinen',
      deleteConfirmation: 'Haluatko varmasti poistaa tämän vapaaehtoisen tietokannasta?',
      selectedVolunteers: {
        one: '1 valittu',
        many: '__count__ valittu',
      },
      keepVolunteer: 'Säilytetään',
      mergeVolunteers: 'Yhdistä __count__ vapaaehtoista',
      mergeVolunteersDialog: {
        title: 'Yhdistä vapaaehtoiset',
        keepVolunteerLabel: 'Valitse säilytettävä vapaaehtoinen. Muut vapaaehtoiset yhdistetään tähän henkilöön.',
        choose: 'Valitse',
        name: 'Vapaaehtoisen nimi',
        merge: 'Yhdistä',
      },
    },
    ballrooms: {
      pageTitle: 'Tanssisalit',
      Nballrooms: {
        one: '1 tanssisali',
        many: '__count__ tanssisalia',
      },
      noBallrooms: 'Ei tanssisaleja',
      addBallroom: 'Lisää tanssisali',
      deleteBallroom: 'Poista tanssisali',
      deleteConfirmation: 'Haluatko varmasti poistaa tämän tanssisalin tietokannasta?',
    },
  },
  versioning: {
    versionHistory: 'Muokkaushistoria',
    version: 'Versio __version__',
    now: 'Nyt',
    newestVersion: 'Tämänhetkinen versio',
    next: 'Seuraava',
    previous: 'Edellinen',
  },
  common: commonTranslations.fi,
}
